module.exports = __webpack_public_path__ + "media/components/stylesheets/Gordita-BoldItalic-be116099b0fd286c3ab45420bc329ad3.woff";